import AvatarText from "@/components/reusables/AvatarText";
import { Checkbox } from "@/components/ui/checkbox";
import { SELECTOR_ID } from "@/constants/global-constants";
import { ExtendedColumnDef } from "@/interfaces/globals";
import { IReturnRequestItem } from "@/interfaces/tools.interface";
import { cn } from "@/lib/utils";

export const useViewReturnRequestProductsColumns = ({
  site,
}: {
  site: string;
}): ExtendedColumnDef<IReturnRequestItem>[] => {
  return [
    {
      map: {
        key: "id",
        valueFrom: "id",
      },
      id: SELECTOR_ID,
      header: ({ table }) => (
        <Checkbox
          checked={
            table.getIsAllPageRowsSelected() ||
            (table.getIsSomePageRowsSelected() && "indeterminate")
          }
          onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
          aria-label='Select all'
          className={cn(
            "hidden group-hover/header:block",
            table.getIsSomePageRowsSelected() && "block",
            table.getIsAllPageRowsSelected() && "!block",
          )}
        />
      ),
      cell: ({ row }) => (
        <Checkbox
          checked={row.getIsSelected()}
          onCheckedChange={(value) => row.toggleSelected(!!value)}
          aria-label='Select row'
          onClick={(e) => e.stopPropagation()}
        />
      ),

      size: 12,
      enableSorting: false,
      enableHiding: false,
    },
    {
      map: {
        key: "Name",
        dataTransformer: (value) => value?.product?.name ?? "-",
      },
      accessorKey: "Name",
      header: "Name",
      cell: ({ row }): JSX.Element => {
        return (
          <AvatarText
            src={row?.original?.product?.images?.[0]}
            name={`${row.original?.product?.name}`}
            title={`${row.original?.product?.name}`}
          />
        );
      },
      meta: {
        minWidth: 200,
        showRightBorder: true,
      },
    },
    {
      map: {
        key: "Quantity",
        dataTransformer: (value) => value?.quantity.toString() ?? "-",
      },
      accessorKey: "Quantity",
      header: "Quantity",
      cell: ({ row }) => row.original?.quantity ?? "-",
      meta: {
        minWidth: 100,
        showRightBorder: true,
      },
    },
    {
      map: {
        key: "Sub Products",
        dataTransformer: (value) =>
          value?.subProducts
            ?.map((subProduct) => subProduct?.name)
            .join(", ") ?? "-",
      },
      accessorKey: "SubProducts",
      header: "Sub Products",
      cell: ({ row }) =>
        row.original?.subProducts
          ?.map((subProduct) => subProduct?.name)
          .join(", ") ?? "-",
      meta: {
        minWidth: 200,
        showRightBorder: true,
      },
    },
    {
      map: {
        key: "Site Assigned",
        dataTransformer: () => site ?? "-",
      },
      accessorKey: "Site Assigned",
      header: "Site Assigned",
      cell: () => site ?? "-",
      meta: {
        minWidth: 200,
      },
    },
  ];
};
